module.exports = __webpack_public_path__ + "images/img-1VOWPVI.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/ranks/4.jpg
// module id = 2037
// module chunks = 0